import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function OwnerUserDetailPage() {
  const { uid } = useParams<{ uid: string }>();
  const [user, setUser] = useState<{ displayName: string; email: string; role: string; companyId?: string } | null>(null);

  useEffect(() => {
    if (!uid) return;
    getDoc(doc(db, 'users', uid)).then((snap) => {
      setUser(snap.exists() ? (snap.data() as { displayName: string; email: string; role: string; companyId?: string }) : null);
    });
  }, [uid]);

  if (!user) return <p className="text-muted-foreground">Cargando...</p>;

  return (
    <div className="space-y-6">
      <Button variant="ghost" size="sm" asChild>
        <Link to="/owner/users">← Usuarios</Link>
      </Button>
      <Card>
        <CardHeader>
          <CardTitle>{user.displayName || user.email}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-1 text-sm">
          <p>Email: {user.email}</p>
          <p>Rol: {user.role}</p>
          <p>Company: {user.companyId ?? '—'}</p>
        </CardContent>
      </Card>
    </div>
  );
}
